import { Editor, Element } from "slate";

import ElementType from "../../../type/slate/ElementType";
import ImageUploadCallback from "../type/ImageUploadCallback";

import insertImage from "./insertImage";

export const insertImageFiles = (
  editor: Editor,
  onUpload: ImageUploadCallback,
  files?: FileList
): boolean => {
  if (files && files.length > 0) {
    for (const file of files) {
      const [mime] = file.type.split("/");
      if (mime === "image") {
        onUpload?.(file, (url: string) => {
          insertImage(editor, file.name, url.toString());
        });
      }
    }
    return true;
  } else {
    return false;
  }
};

const withImages = (editor: Editor, onImageUpload?: ImageUploadCallback) => {
  const { insertData, isInline, isVoid } = editor;

  editor.isInline = (element: Element) => {
    return Element.isElementType(element, ElementType.IMAGE) || isInline(element);
  };

  editor.isVoid = (element) => {
    return element.type === ElementType.IMAGE ? true : isVoid(element);
  };

  editor.insertData = (data) => {
    const { files } = data;
    if (onImageUpload && !insertImageFiles(editor, onImageUpload, files)) {
      insertData(data);
    }
  };

  return editor;
};

export default withImages;
